import { createAppTheme } from '@hwm/ui-lib/ui/styles';
import { styleConstants } from './constants';

const theme = createAppTheme(styleConstants);

export default theme;
